module.exports = __webpack_public_path__ + "static/media/cloud.f83d2f0d.svg";